import React from 'react'

const CreateRepoBtn = () => {

  return (
    <button className='createBtn'>Create repository</button>
  )
}

export default CreateRepoBtn